import React, { useEffect, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Hidden,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Avatar,
} from "@material-ui/core"
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded"
import Link from "@material-ui/core/Link"
import InfiniteScroll from "react-infinite-scroll-component"
import { Fragment } from "react"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import _ from "lodash"
import { convertToAbbr } from "../../lib/states"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import crewmamaCrown from "../../assets/images/crewmama_crown.svg"
import {
  toggleDeleteClientCompanyDialog,
  _setEditClientCompany,
} from "../../actions/clients"
import CloseIcon from "@material-ui/icons/Close"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined"
import EditOutlinedIcon from "@material-ui/icons/EditOutlined"
import CircleAvatar from "../CircleAvatar/index"

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  mobileTableRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: 0,
    paddingRight: "0 !important",
  },
  mobileClientName: { fontSize: "0.8rem", fontWeight: 600 },
  collapseStyles: { boxShadow: "none", border: "none", width: "100%" },
  collapseSummary: {
    width: "100%",
    justifyContent: "space-between",
    margin: 0,
    display: "flex",
  },
  collapseDetails: {
    padding: "0px",
    width: "100%",
    backgroundColor: "#f8f8f8",
  },
  collapseDetailsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  collapseDetailsRow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    padding: "10px",
  },
  collapseDetailsLastRow: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
  collapseSummaryRow: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  representativeLogo: {
    width: "40px",
    height: "40px",
  },
})

const pageSize = 50

export default function BasicTable(props) {
  const classes = useStyles()
  const [page, setPage] = useState(1)
  const hasClients = props.clientList && props.clientList.length != 0
  const pagedClients = hasClients && props.clientList.slice(0, page * pageSize)

  //put logic for the fab button on the mobile
  useEffect(
    () => {
      setPage(1)
    },
    [JSON.stringify(props.clientList)]
  )

  return (
    <Fragment>
      {/* WEB VIEW */}
      <Hidden smDown>
        <div style={{ margin: "20px", width: "97%" }}>
          <Paper>
            <InfiniteScroll
              next={() => setPage(page + 1)}
              hasMore={props.clientList.length > page * pageSize}
              dataLength={pagedClients.length}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {/* <TableCell>GTT</TableCell>
                    <TableCell>ADD</TableCell> */}
                    <TableCell>Name</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Logo</TableCell>
                    <TableCell>Email</TableCell>
                    {/* <TableCell>EIN / SSN</TableCell> */}
                    <TableCell>SSN</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                {hasClients && (
                  <TableBody>
                    {pagedClients.map((cl, i) => (
                      <TableRow key={i}>
                        <TableCell>{cl.name}</TableCell>
                        <TableCell>
                          {cl.location && cl.location
                            ? `${JSON.parse(cl.location).city}, ${_.head(convertToAbbr(JSON.parse(cl.location).state)) &&
                            _.head(convertToAbbr(JSON.parse(cl.location).state)).abbr}`
                            : "-"}
                        </TableCell>
                        <TableCell>
                          <img
                            className={classes.representativeLogo}
                            src={cl.logo_image !== null && JSON.parse(cl.logo_image).public_id && JSON.parse(cl.logo_image).format ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload/v${JSON.parse(cl.logo_image).version}/${JSON.parse(cl.logo_image).public_id.replace(/\s/g, '')}.${JSON.parse(cl.logo_image).format.replace(/\s/g, '')}` : ""}
                            alt={`${cl.name}`}
                            style={{ objectFit: "contain", width: "40px", height: "40px" }}
                          />
                        </TableCell>
                        <TableCell>{cl.email}</TableCell>
                        <TableCell>
                          {cl.ein_ssn
                            ? cl.is_ein === 1
                              ? `(EIN) ${cl.ein_ssn}`
                              : `(SSN)  ${cl.ein_ssn}`
                            : "-"}
                        </TableCell>
                        <TableCell>
                          <EditOutlinedIcon
                            style={{
                              color: "#dc004e",
                              cursor: "pointer",
                              marginRight: "10px",
                            }}
                            onClick={() => props.openClientProfile(cl)}
                            aria-label="Close"
                          >
                            <CloseIcon classes={{ root: classes.closeIcon }} />
                          </EditOutlinedIcon>

                          <DeleteOutlinedIcon
                            style={{
                              color: "#dc004e",
                              cursor: "pointer",
                              marginLeft: "10px",
                            }}
                            onClick={() => props.deleteClient(cl)}
                            aria-label="Close"
                          >
                            <CloseIcon classes={{ root: classes.closeIcon }} />
                          </DeleteOutlinedIcon>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>

              {!hasClients && (
                <Box>
                  <Typography variant="h4">No Companies Found</Typography>
                </Box>
              )}
            </InfiniteScroll>
          </Paper>
        </div>
      </Hidden>

      {/* MOBILE VIEW */}
      <Hidden mdUp>
        <div>
          <Paper>
            <InfiniteScroll
              next={() => setPage(page + 1)}
              hasMore={props.clientList.length > page * pageSize}
              dataLength={pagedClients.length}
            >
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                  </TableRow>
                </TableHead>
                {hasClients && (
                  <TableBody>
                    {pagedClients.map((cl, i) => (
                      <TableRow key={i}>
                        <TableCell className={classes.mobileTableRow}>
                          <ExpansionPanel
                            key={i}
                            className={classes.collapseStyles}
                          >
                            <ExpansionPanelSummary
                              className={classes.collapseSummary}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Box
                                component="div"
                                m={1}
                                className={classes.collapseSummaryRow}
                              >
                                <Typography
                                  variant="p"
                                  className={classes.mobileClientName}
                                >
                                  {cl.name}
                                </Typography>
                                <ArrowDropDownIcon />
                              </Box>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails
                              className={classes.collapseDetails}
                            >
                              <Box
                                component="div"
                                m={1}
                                className={classes.collapseDetailsContainer}
                              >
                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">Location</Typography>
                                  <Typography variant="p">
                                    {cl.location && cl.location
                                      ? `${JSON.parse(cl.location).city}, 
  ${_.head(convertToAbbr(JSON.parse(cl.location).state)) &&
                                      _.head(convertToAbbr(JSON.parse(cl.location).state)).abbr}`
                                      : "-"}
                                  </Typography>
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">Email</Typography>
                                  <Typography variant="p">
                                    {cl.email}
                                  </Typography>
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">Logo</Typography>
                                  <Typography variant="p">


                                    <img
                                      className={classes.representativeLogo}


                                      src={cl.logo_image !== null && JSON.parse(cl.logo_image).public_id && JSON.parse(cl.logo_image).format ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload/v${JSON.parse(cl.logo_image).version}/${JSON.parse(cl.logo_image).public_id.replace(/\s/g, '')}.${JSON.parse(cl.logo_image).format.replace(/\s/g, '')}` : ""}
                                      alt={`${cl.name}`}
                                    />
                                  </Typography>
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsRow}
                                >
                                  <Typography variant="p">EIN / SSN</Typography>
                                  <Typography variant="p">
                                    {cl.ein_ssn
                                      ? cl.is_ein === 1
                                        ? `(EIN) ${cl.ein_ssn}`
                                        : `(SSN)  ${cl.ein_ssn}`
                                      : "-"}
                                  </Typography>
                                </Box>

                                <Box
                                  component="div"
                                  m={1}
                                  className={classes.collapseDetailsLastRow}
                                >
                                  <EditOutlinedIcon
                                    style={{
                                      color: "#dc004e",
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                    onClick={() => props.openClientProfile(cl)}
                                    aria-label="Close"
                                  >
                                    <CloseIcon
                                      classes={{ root: classes.closeIcon }}
                                    />
                                  </EditOutlinedIcon>

                                  <DeleteOutlinedIcon
                                    style={{
                                      color: "#dc004e",
                                      cursor: "pointer",
                                      marginLeft: "10px",
                                    }}
                                    onClick={() => props.deleteClient(cl)}
                                    aria-label="Close"
                                  >
                                    <CloseIcon
                                      classes={{ root: classes.closeIcon }}
                                    />
                                  </DeleteOutlinedIcon>
                                </Box>
                              </Box>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>

              {!hasClients && (
                <Box>
                  <Typography variant="h4">No Clients Found</Typography>
                </Box>
              )}
            </InfiniteScroll>
          </Paper>
        </div>
      </Hidden>
    </Fragment>
  )
}
